module.exports = __webpack_public_path__ + "static/media/Iris Street, San Francisco, CA5.48d7df97.jpg";